import { BrandConfig } from './types';

/**
 * The policy markdown is a template written for another platform. Its platform name and
 * legal entity become the viewing brand's, so a Lenvoy page never says "Autopilotee Cars".
 * Replacers are functions so a `$` in a name is never read as a replacement pattern.
 */
export const applyBrandNames = (
  content: string,
  brand: Pick<BrandConfig, 'name' | 'legalName'>,
): string =>
  content.replace(/Turo Inc\./gi, () => brand.legalName).replace(/Turo/gi, () => brand.name);
